export const mainLinks = [
  {
    href: '/news',
    title: 'Новости',
  },

  {
    href: '/faq',
    title: 'FAQ',
  },

  {
    href: 'https://wiki.after-the-end.pro/',
    title: 'Wiki',
  },
];